import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { 
    FaHistory, FaSearch, FaFilter, FaTimes, FaLock, FaLockOpen, FaClock, 
    FaMapMarkerAlt, FaChartBar, FaDollarSign, FaTrash, FaVenusMars, 
    FaUserPlus, FaUserEdit, FaKey, FaUserMinus, FaGlobe, FaExchangeAlt, 
    FaTimesCircle, FaClipboardCheck, FaClipboard, FaRedo, FaCalendarPlus, 
    FaCalendarMinus, FaChevronLeft, FaChevronRight, FaSpinner 
} from 'react-icons/fa';
import { activityLogService } from '../../services/activityLogService';
import { getAllRegionalUsers } from '../../services/regionalUserService';
import api from '../../services/api';
import './ActivityLogs.scss';

const ACTION_CONFIG = {
    'BlockedSlotCreated':          { label: 'Blokaj Eklendi',              icon: FaLock,           color: 'var(--arc-danger-text)',   bg: 'var(--arc-danger-subtle)',   border: 'rgba(239, 68, 68, 0.25)' },
    'BlockedSlotDeleted':          { label: 'Blokaj Kaldırıldı',           icon: FaLockOpen,       color: 'var(--arc-success-text)',  bg: 'var(--arc-success-subtle)',  border: 'rgba(16, 185, 129, 0.25)' },
    'PricingCreated':              { label: 'Fiyat Eklendi',               icon: FaDollarSign,     color: 'var(--arc-primary-text)',  bg: 'var(--arc-primary-subtle)',  border: 'rgba(37, 99, 235, 0.25)' },
    'PricingDeleted':              { label: 'Fiyat Silindi',               icon: FaTrash,          color: 'var(--arc-danger-text)',   bg: 'var(--arc-danger-subtle)',   border: 'rgba(239, 68, 68, 0.25)' },
    'GenderRestrictionSaved':      { label: 'Cinsiyet Kısıtlaması',        icon: FaVenusMars,      color: 'var(--arc-primary-text)',  bg: 'var(--arc-primary-subtle)',  border: 'rgba(37, 99, 235, 0.25)' },
    'ClubPricingSaved':            { label: 'Kulüp Fiyatı Güncellendi',    icon: FaDollarSign,     color: 'var(--arc-primary-text)',  bg: 'var(--arc-primary-subtle)',  border: 'rgba(37, 99, 235, 0.25)' },
    'ClubPricingDeleted':          { label: 'Kulüp Fiyatı Silindi',        icon: FaTrash,          color: 'var(--arc-danger-text)',   bg: 'var(--arc-danger-subtle)',   border: 'rgba(239, 68, 68, 0.25)' },
    'RegionalUserCreated':         { label: 'Kullanıcı Oluşturuldu',       icon: FaUserPlus,       color: 'var(--arc-success-text)',  bg: 'var(--arc-success-subtle)',  border: 'rgba(16, 185, 129, 0.25)' },
    'RegionalUserUpdated':         { label: 'Kullanıcı Güncellendi',       icon: FaUserEdit,       color: 'var(--arc-warning-text)',  bg: 'var(--arc-warning-subtle)',  border: 'rgba(245, 158, 11, 0.25)' },
    'RegionalUserPasswordChanged': { label: 'Şifre Değiştirildi',          icon: FaKey,            color: 'var(--arc-primary-text)',  bg: 'var(--arc-primary-subtle)',  border: 'rgba(37, 99, 235, 0.25)' },
    'RegionalUserDeleted':         { label: 'Kullanıcı Silindi',           icon: FaUserMinus,      color: 'var(--arc-danger-text)',   bg: 'var(--arc-danger-subtle)',   border: 'rgba(239, 68, 68, 0.25)' },
    'RegionAssigned':              { label: 'Bölge Atandı',                icon: FaGlobe,          color: 'var(--arc-primary-text)',  bg: 'var(--arc-primary-subtle)',  border: 'rgba(37, 99, 235, 0.25)' },
    'AppointmentTransferred':      { label: 'Randevu Aktarıldı',           icon: FaExchangeAlt,    color: 'var(--arc-warning-text)',  bg: 'var(--arc-warning-subtle)',  border: 'rgba(245, 158, 11, 0.25)' },
    'AppointmentCancelled':        { label: 'Randevu İptal Edildi',        icon: FaTimesCircle,    color: 'var(--arc-danger-text)',   bg: 'var(--arc-danger-subtle)',   border: 'rgba(239, 68, 68, 0.25)' },
    'ClubApplicationStatusUpdated':{ label: 'Başvuru Durumu Güncellendi',   icon: FaClipboardCheck, color: 'var(--arc-warning-text)',  bg: 'var(--arc-warning-subtle)',  border: 'rgba(245, 158, 11, 0.25)' },
    'ClubApplicationDeleted':      { label: 'Başvuru Silindi',             icon: FaClipboard,      color: 'var(--arc-danger-text)',   bg: 'var(--arc-danger-subtle)',   border: 'rgba(239, 68, 68, 0.25)' },
    'ClubMembershipRenewed':       { label: 'Üyelik Yenilendi',            icon: FaRedo,           color: 'var(--arc-success-text)',  bg: 'var(--arc-success-subtle)',  border: 'rgba(16, 185, 129, 0.25)' },
    'ClubTimeSlotAssigned':        { label: 'Kulübe Saat Atandı',          icon: FaCalendarPlus,   color: 'var(--arc-primary-text)',  bg: 'var(--arc-primary-subtle)',  border: 'rgba(37, 99, 235, 0.25)' },
    'ClubTimeSlotRemoved':         { label: 'Kulüp Saat Kaldırıldı',       icon: FaCalendarMinus,  color: 'var(--arc-danger-text)',   bg: 'var(--arc-danger-subtle)',   border: 'rgba(239, 68, 68, 0.25)' },
};


const SOURCE_LABELS = { 'Maintenance': 'Bakım', 'MemberHour': 'Üye Saati', 'MinistryHour': 'Bakanlık Saati' };
const DAY_NAMES = { 0: 'Pazar', 1: 'Pazartesi', 2: 'Salı', 3: 'Çarşamba', 4: 'Perşembe', 5: 'Cuma', 6: 'Cumartesi' };
const GENDER_MAP = { 'Male': 'Erkek', 'Female': 'Kadın', 'All': 'Tümü' };
const STATUS_MAP = { 'Approved': 'Onaylandı', 'Rejected': 'Reddedildi', 'Pending': 'Beklemede' };

const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
        ' ' + d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
};

const parseDetails = (details) => {
    if (!details) return null;
    try { return JSON.parse(details); } catch { return null; }
};

const getDetailSummary = (action, details) => {
    const d = parseDetails(details);
    if (!d) return details || '-';
    const p = [];
    switch (action) {
        case 'BlockedSlotCreated': case 'BlockedSlotDeleted':
            if (d.StartTime && d.EndTime) p.push(`${d.StartTime} – ${d.EndTime}`);
            if (d.BlockSource) p.push(SOURCE_LABELS[d.BlockSource] || d.BlockSource);
            if (d.Reason) p.push(d.Reason);
            if (d.IsWeekly) p.push('Haftalık');
            if (d.BlockedDate) p.push(new Date(d.BlockedDate).toLocaleDateString('tr-TR'));
            break;
        case 'PricingCreated': case 'PricingDeleted':
            if (d.StartTime && d.EndTime) p.push(`${d.StartTime} – ${d.EndTime}`);
            if (d.Price != null) p.push(`${d.Price} ₺`);
            if (d.DayOfWeek != null) p.push(DAY_NAMES[d.DayOfWeek] || `Gün ${d.DayOfWeek}`);
            break;
        case 'GenderRestrictionSaved':
            if (d.AllowedGender) p.push(GENDER_MAP[d.AllowedGender] || d.AllowedGender);
            if (d.DayOfWeek != null) p.push(DAY_NAMES[d.DayOfWeek]);
            if (d.StartTime && d.EndTime) p.push(`${d.StartTime} – ${d.EndTime}`);
            break;
        case 'ClubPricingSaved':
            if (d.PricePerHour != null) p.push(`Saatlik: ${d.PricePerHour} ₺`);
            if (d.NightPricePerHour != null) p.push(`Gece: ${d.NightPricePerHour} ₺`);
            if (d.Action) p.push(d.Action === 'Updated' ? 'Güncellendi' : 'Yeni');
            break;
        case 'ClubPricingDeleted':
            if (d.PricePerHour != null) p.push(`${d.PricePerHour} ₺`); break;
        case 'RegionalUserCreated':
            if (d.Username) p.push(`@${d.Username}`);
            if (d.FirstName && d.LastName) p.push(`${d.FirstName} ${d.LastName}`);
            if (d.Email) p.push(d.Email);
            break;
        case 'RegionalUserUpdated':
            if (d.FirstName && d.LastName) p.push(`${d.FirstName} ${d.LastName}`);
            if (d.IsActive != null) p.push(d.IsActive ? 'Aktif' : 'Pasif');
            break;
        case 'RegionalUserPasswordChanged':
            if (d.UserName) p.push(d.UserName); break;
        case 'RegionalUserDeleted':
            if (d.UserName) p.push(d.UserName);
            if (d.Username) p.push(`@${d.Username}`);
            break;
        case 'RegionAssigned':
            if (d.UserName) p.push(d.UserName);
            if (d.RegionIds) p.push(`${d.RegionIds.length} bölge`);
            break;
        case 'AppointmentTransferred':
            if (d.AppointmentId) p.push(`#${d.AppointmentId}`);
            if (d.NewDate) p.push(new Date(d.NewDate).toLocaleDateString('tr-TR'));
            if (d.NewStartTime && d.NewEndTime) p.push(`${d.NewStartTime} – ${d.NewEndTime}`);
            break;
        case 'AppointmentCancelled':
            if (d.AppointmentId) p.push(`Randevu #${d.AppointmentId}`); break;
        case 'ClubApplicationStatusUpdated':
            if (d.Status) p.push(STATUS_MAP[d.Status] || d.Status);
            if (d.MembershipMonths) p.push(`${d.MembershipMonths} ay`);
            if (d.Notes) p.push(d.Notes);
            break;
        case 'ClubApplicationDeleted':
            if (d.ApplicationId) p.push(`Başvuru #${d.ApplicationId}`); break;
        case 'ClubMembershipRenewed':
            if (d.MembershipMonths) p.push(`${d.MembershipMonths} ay uzatıldı`); break;
        case 'ClubTimeSlotAssigned':
            if (d.ClubRepresentative) p.push(d.ClubRepresentative);
            if (d.DayOfWeek != null) p.push(DAY_NAMES[d.DayOfWeek]);
            if (d.StartTime && d.EndTime) p.push(`${d.StartTime} – ${d.EndTime}`);
            break;
        case 'ClubTimeSlotRemoved':
            if (d.AssignmentId) p.push(`Atama #${d.AssignmentId}`); break;
        default: return details;
    }
    return p.join(' • ') || '-';
};

const ActivityLogs = () => {
    const [logs, setLogs] = useState([]);
    const [users, setUsers] = useState([]);
    const [facilities, setFacilities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedFacility, setSelectedFacility] = useState('');
    const [filters, setFilters] = useState({
        userId: '', action: '', startDate: '', endDate: ''
    });
    const [appliedFilters, setAppliedFilters] = useState({});
    
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;

    useEffect(() => {
        loadUsers();
        loadFacilities();
        loadLogs({});
    }, []);

    const loadUsers = async () => {
        try {
            const res = await getAllRegionalUsers();
            if (res?.isSuccess) setUsers(res.data);
        } catch (err) {
            console.error('Kullanıcılar yüklenemedi:', err);
        }
    };

    const loadFacilities = async () => {
        try {
            const res = await api.get('/api/sports-management/facilities');
            if (res?.isSuccess) setFacilities(res.data);
        } catch (err) {
            console.error('Tesisler yüklenemedi:', err);
        }
    };

    const loadLogs = useCallback(async (filterParams) => {
        setLoading(true);
        try {
            const res = await activityLogService.getLogs(filterParams);
            if (res?.isSuccess) {
                setLogs(res.data);
                setCurrentPage(1); // Reset to first page on new data
            }
        } catch (err) {
            console.error('Loglar yüklenemedi:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    const userMap = useMemo(() => {
        const map = {};
        users.forEach(u => {
            if (u.username) map[u.username.toLowerCase()] = u;
            if (u.id) map[`id_${u.id}`] = u;
            const fullName = `${u.firstName} ${u.lastName}`;
            map[fullName.toLowerCase()] = u;
        });
        return map;
    }, [users]);

    const resolveUser = (log) => {
        if (!users.length) return { name: log.userName || 'Bilinmiyor', email: '-', username: log.userName || '-' };
        const match = userMap[log.userName?.toLowerCase()]
            || userMap[`id_${log.userId}`]
            || userMap[`${log.userName}`.toLowerCase()];
        if (match) {
            return {
                name: `${match.firstName} ${match.lastName}`,
                email: match.email || '-',
                username: match.username || '-'
            };
        }
        return { name: log.userName || 'Bilinmiyor', email: '-', username: log.userName || '-' };
    };

    const handleApplyFilters = () => {
        const params = {};
        if (filters.userId) params.userId = filters.userId;
        if (filters.action) params.action = filters.action;
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        setAppliedFilters(params);
        loadLogs(params);
    };

    const handleClearFilters = () => {
        setFilters({ userId: '', action: '', startDate: '', endDate: '' });
        setAppliedFilters({});
        loadLogs({});
    };

    const activeFilterCount = Object.values(appliedFilters).filter(Boolean).length;

    const filteredLogs = useMemo(() => {
        let result = logs;

        if (selectedFacility) {
            result = result.filter(l => l.facilityName === selectedFacility);
        }

        if (searchText.trim()) {
            const q = searchText.toLowerCase();
            result = result.filter(log => {
                const user = resolveUser(log);
                return (
                    user.name.toLowerCase().includes(q) ||
                    user.username.toLowerCase().includes(q) ||
                    user.email.toLowerCase().includes(q) ||
                    (log.facilityName || '').toLowerCase().includes(q) ||
                    getDetailSummary(log.action, log.details).toLowerCase().includes(q)
                );
            });
        }

        return result;
    }, [logs, searchText, selectedFacility, userMap]);

    // Paginated logs
    const paginatedLogs = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredLogs.slice(startIndex, startIndex + itemsPerPage);
    }, [filteredLogs, currentPage]);

    const totalPages = Math.ceil(filteredLogs.length / itemsPerPage);

    return (
        <div className="activity-logs-container">
            {/* Page Header */}
            <div className="activity-header">
                <div className="header-left">
                    <div className="title-info">
                        <h1>Aktivite Kayıtları</h1>
                        <p>
                            {filteredLogs.length > 0 ? `${filteredLogs.length} kayıt listeleniyor` : 'Tüm sistem hareketleri'}
                        </p>
                    </div>
                </div>
                <div className="header-date">
                    {new Date().toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
                </div>
            </div>

            {/* Search & Filter Bar */}
            <div className="filter-bar">
                {/* Search */}
                <div className="filter-item">
                    <label>Arama</label>
                    <div className="search-input-wrapper">
                        <FaSearch size={12} />
                        <input
                            type="text"
                            placeholder="İsim, kullanıcı, tesis..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>
                </div>

                {/* Facility Filter */}
                <div className="filter-item">
                    <label>Tesis</label>
                    <select value={selectedFacility} onChange={(e) => setSelectedFacility(e.target.value)}>
                        <option value="">Tüm Tesisler</option>
                        {facilities.map(f => (
                            <option key={f.facilityId} value={f.facilityName}>{f.facilityName}</option>
                        ))}
                    </select>
                </div>

                {/* User Filter */}
                <div className="filter-item">
                    <label>Kullanıcı</label>
                    <select value={filters.userId} onChange={(e) => setFilters({ ...filters, userId: e.target.value })}>
                        <option value="">Tüm Kullanıcılar</option>
                        {users.map(u => (
                            <option key={u.id} value={u.id}>{u.firstName} {u.lastName}</option>
                        ))}
                    </select>
                </div>

                {/* Action Filter */}
                <div className="filter-item">
                    <label>İşlem Tipi</label>
                    <select value={filters.action} onChange={(e) => setFilters({ ...filters, action: e.target.value })}>
                        <option value="">Tüm İşlemler</option>
                        {Object.entries(ACTION_CONFIG).map(([key, val]) => (
                            <option key={key} value={key}>{val.label}</option>
                        ))}
                    </select>
                </div>

                {/* Date Filters */}
                <div className="filter-item">
                    <label>Başlangıç</label>
                    <input type="date" value={filters.startDate} onChange={(e) => setFilters({ ...filters, startDate: e.target.value })} />
                </div>
                <div className="filter-item">
                    <label>Bitiş</label>
                    <input type="date" value={filters.endDate} onChange={(e) => setFilters({ ...filters, endDate: e.target.value })} />
                </div>

                {/* Action Buttons */}
                <div className="filter-actions">
                    <button className="btn-search" onClick={handleApplyFilters}>
                        <FaSearch size={12} /> Ara
                    </button>
                    {activeFilterCount > 0 && (
                        <button className="btn-clear" onClick={handleClearFilters}>
                            <FaTimes size={12} /> Temizle
                        </button>
                    )}
                </div>
            </div>

            {/* Table Card */}
            <div className="logs-table-card">
                {loading ? (
                    <div className="loading-container" style={{ textAlign: 'center', padding: '3rem 1rem' }}>
                        <FaSpinner className="icon spin" style={{ fontSize: '2rem', color: 'var(--arc-primary)', animation: 'spin 1s linear infinite' }} />
                        <p style={{ marginTop: '12px', color: 'var(--arc-text-secondary)', fontWeight: '500' }}>Yükleniyor...</p>
                    </div>
                ) : filteredLogs.length === 0 ? (
                    <div className="empty-container">
                        <FaHistory className="icon" />
                        <p>{logs.length > 0 ? 'Aramanızla eşleşen kayıt yok' : 'Henüz kayıt bulunmuyor'}</p>
                    </div>
                ) : (
                    <>
                        <div className="table-wrapper">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        {['Tarih', 'Kullanıcı', 'Kullanıcı Adı', 'İşlem', 'Tesis', 'Detay', 'IP'].map(h => (
                                            <th key={h}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedLogs.map(log => {
                                        const actionInfo = ACTION_CONFIG[log.action] || { label: log.action, icon: FaHistory, color: '#4a5568', bg: '#f7fafc' };
                                        const ActionIcon = actionInfo.icon;
                                        const user = resolveUser(log);

                                        return (
                                            <tr key={log.id}>
                                                <td>
                                                    <div className="time-cell">
                                                        <FaClock size={11} color="#a0aec0" />
                                                        {formatDateTime(log.createdAt)}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="user-cell">
                                                        <div className="name">{user.name}</div>
                                                        <div className="email">{user.email}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="username-badge">{user.username}</span>
                                                </td>
                                                <td>
                                                    <span 
                                                        className="action-badge" 
                                                        style={{ background: actionInfo.bg, color: actionInfo.color, borderColor: actionInfo.border || 'transparent' }}
                                                    >
                                                        <ActionIcon size={11} />
                                                        {actionInfo.label}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="facility-cell">
                                                        <FaMapMarkerAlt size={11} color="var(--arc-primary)" />
                                                        {log.facilityName || '-'}
                                                    </div>
                                                </td>
                                                <td className="details-text">
                                                    {getDetailSummary(log.action, log.details)}
                                                </td>
                                                <td className="ip-text">
                                                    {log.ipAddress || '—'}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination Controls */}
                        {totalPages > 1 && (
                            <div className="pagination-wrapper">
                                <button 
                                    className="page-btn" 
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                >
                                    <FaChevronLeft />
                                </button>
                                
                                {[...Array(totalPages)].map((_, i) => {
                                    const pageNum = i + 1;
                                    const isVisible = pageNum === 1 || pageNum === totalPages || (pageNum >= currentPage - 2 && pageNum <= currentPage + 2);
                                    
                                    if (!isVisible) return null;
                                    
                                    return (
                                        <button 
                                            key={pageNum}
                                            className={`page-btn ${currentPage === pageNum ? 'active' : ''}`}
                                            onClick={() => setCurrentPage(pageNum)}
                                        >
                                            {pageNum}
                                        </button>
                                    );
                                })}

                                <button 
                                    className="page-btn" 
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                >
                                    <FaChevronRight />
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default ActivityLogs;
